import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Link as RouterLink } from 'react-router-dom';
/**
 * Component that renders a link based on the provided template and value.
 *
 * @param {string} props.linkTemplate - The template for the link, where `:value` will be replaced with the actual value.
 * @param {boolean} props.openNewTab - Flag indicating whether the link should open in a new tab.
 * @param {string | number} props.value - The value to be inserted into the link template.
 *
 * @returns {JSX.Element} A link element if the link template is provided, otherwise the value itself.
 */
export function CellLink({ linkTemplate, openNewTab, value }) {
    const link = linkTemplate?.replace(':value', String(value));
    if (!link) {
        return _jsx(_Fragment, { children: value });
    }
    if (openNewTab) {
        return (_jsx("a", { href: link, target: '_blank', rel: 'noopener noreferrer', children: value }));
    }
    return _jsx(RouterLink, { to: link, children: value });
}
